module.exports = {
  themeColor: '#8CC63F', // 这个色号必须和主题色是一个颜色才行，要不然出来的css模板文件是空的
  blackColor: '#222131',
  // vue-ls options
  storageOptions: {
    namespace: 'pro__', // key prefix
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'local', // storage name session, local, memory
  },
}
